import { useQuery } from '@tanstack/react-query';
import { getUserProfileInfo } from '../requests';
import { useSessionStore } from '@/entities/session';
import { CACHE_TIME_10_MINUTES, CACHE_TIME_5_MINUTES } from '@/shared/config';
import { buildUserProfileInfoMap } from '../../lib';

const useUserProfileInfo = () => {
  const { session } = useSessionStore();
  const { data, isLoading, error } = useQuery({
    queryKey: ['userProfileInfo', session?.userId],
    queryFn: getUserProfileInfo,
    enabled: !!session?.userId,
    staleTime: CACHE_TIME_5_MINUTES,
    gcTime: CACHE_TIME_10_MINUTES,
  });

  const userProfileInfoMap = buildUserProfileInfoMap(data?.userData ?? []);

  return {
    userProfileInfo: data,
    userProfileInfoMap,
    isUserProfileInfoLoading: isLoading,
    userProfileInfoError: error,
  };
};

export { useUserProfileInfo };
